import {
  configurePlatform,
  type AppEnv,
  type AuthNavigator,
  type TokenStorage,
  type UiFeedback,
  type ToastSeverity,
} from '@gusiberi/shared'

type DispatchLike = (action: any) => void

let dispatchRef: DispatchLike | null = null

export function setFeedbackDispatch(dispatch: DispatchLike) {
  dispatchRef = dispatch
}

export const webStorage: TokenStorage = {
  getToken: () => localStorage.getItem('user_token'),
  setToken: (token: string) => localStorage.setItem('user_token', token),
  getUsername: () => localStorage.getItem('username'),
  setUsername: (username: string) => localStorage.setItem('username', username),
  clear: () => {
    localStorage.clear()
    sessionStorage.clear()
  },
}

export const webEnv: AppEnv = {
  apiBaseUrl:
    process.env.NODE_ENV === 'production'
      ? (process.env.REACT_APP_API_URL as string)
      : /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          typeof navigator !== 'undefined' ? navigator.userAgent : ''
        )
        ? 'http://10.0.0.55:8000/api/v1'
        : 'http://localhost:8000/api/v1',
  isProduction: process.env.NODE_ENV === 'production',
  encryptionKey: process.env.REACT_APP_ENCRYPTION_KEY || '',
  awsBaseUrl: process.env.REACT_APP_AWS_BASE_URL,
}

export const webNavigator: AuthNavigator = {
  goToAuth: () => {
    window.location.href = '/auth'
  },
}

/** Feedback wired after Redux store exists via setFeedbackDispatch. */
export const webFeedback: UiFeedback = {
  showToast: (message: string, severity: ToastSeverity = 'success') => {
    const { showToastMessage } = require('../stores/uiStore')
    dispatchRef?.(showToastMessage({ message, severity }))
  },
  setLoadingMessage: (message: string) => {
    const { setLoadingScreenMessage } = require('../stores/uiStore')
    dispatchRef?.(setLoadingScreenMessage(message))
  },
  clearLoading: () => {
    const { clearLoadingScreen } = require('../stores/uiStore')
    dispatchRef?.(clearLoadingScreen())
  },
  closeDialog: () => {
    const { closeDialog } = require('../stores/uiStore')
    dispatchRef?.(closeDialog())
  },
}

export function configureWebPlatform() {
  configurePlatform({
    storage: webStorage,
    env: webEnv,
    navigator: webNavigator,
    feedback: webFeedback,
  })
}
